import _ from 'lodash';
import TokenStore from '../stores/TokenStore';
import CookieHelper from '../helpers/Cookie';
import FeatureFlagStore from '../stores/FeatureFlagStore';
import OrderStore from '../stores/OrderStore';
import { CookieKeys } from '../constants/AppConstants';

const getOrderCookieJourneys = (currentOrder) => {
    return currentOrder.trips.reduce((acc, orderTrip) => {
        const fares = orderTrip.getJourneyFares();

        fares.forEach(fare => {
            const journey = {
                id: orderTrip.id,
                isReturn: orderTrip.isReturn(),
                ticketType: fare.ticketType.name,
                adults: fare.adults(),
                children: fare.children(),
                railcards: fare.getRailcards().map(r => r.name).toJS(),
                restrictions: fare.getDescription(),
                price: fare.getTotalPrice(),
                origin: _.get(fare, 'origin.name') || _.get(fare, 'outwardJourney.getOrigin().name'),
                destination: _.get(fare, 'destination.name') || _.get(fare, 'outwardJourney.getDestination().name'),
            };

            const returnJourney = orderTrip.isReturn() && acc.find(({ id }) => id === orderTrip.id);
            if (returnJourney) {
                acc = acc.map(outboundJourney => outboundJourney.id === orderTrip.id ? ({
                    ...outboundJourney,
                    originReturn: journey.origin,
                    destinationReturn: journey.destination,
                    ticketTypeReturn: journey.ticketType,
                    restrictionsReturn: journey.restrictions,
                    price: journey.price + outboundJourney.price,
                    railcards: _.union(outboundJourney.railcards, journey.railcards),
                }) : outboundJourney);
            } else {
                acc = [...acc, journey];
            }
        });
        return acc;
    }, []);
};

const prepareOrderCookie = (currentOrder) => {
    return {
        id: currentOrder.id,
        totalPrice: currentOrder.totalPrice,
        journeysAmount: currentOrder.trips.size,
        journeys: getOrderCookieJourneys(currentOrder),
    };
};

export const updateOrderCookie = (order) => {
    if (FeatureFlagStore.get('enableBasketWidget')) {
        const currentOrder = OrderStore.getCurrent();

        const orderData = {
            device: TokenStore.getDevice(),
            order: order || prepareOrderCookie(currentOrder)
        };

        const orderDataJSON = JSON.stringify(orderData);
        const encodedOrderData = btoa(orderDataJSON);

        CookieHelper.set(CookieKeys.ORDER, encodedOrderData, {}, false);
    }
};



// WEBPACK FOOTER //
// ./src/utils/orderUtils.js